import React from 'react'
import { useSelector } from 'react-redux'

import { getOrganizationDomain } from 'helpers/URLHelper'
import { getCurrentUser } from 'data/users/selectors'

import { Button, Text } from 'components/base'
import logoSrc from 'assets/images/slite-app-round-logo.svg'
import { isAndroid } from '../../helpers/DesktopHelpers'
import { GooglePlayIcon, IOSIcon } from '../Utils/Icons'

function DownloadButton({ to, icon, text, title }) {
  return (
    <a href={to}>
      <Button.Primary
        className="flexbox margin-bottom-largest"
        style={{ padding: '16px 24px', height: 64 }}
      >
        <div className="margin-right-normal">{icon}</div>
        <div className="nowrap text-align-left line-height-small">
          <div className="font-weight-medium font-size-small line-height-normal">
            {text}
          </div>
          <div
            className="font-size-medium bold"
            style={{ lineHeight: '1.4em' }}
          >
            {title}
          </div>
        </div>
      </Button.Primary>
    </a>
  )
}

export default function UnsupportedDevice() {
  const organizationDomain = getOrganizationDomain()

  const userEmail = useSelector(state => {
    const user = getCurrentUser(state)
    return user && user.email
  })

  return (
    <div>
      <div className="flexbox flexbox-column padding-largest">
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <div className="flexbox flexbox-column flexbox-align-center">
          <img
            src={logoSrc}
            width="52"
            alt="slite"
            className="margin-bottom-largest shadow-normal margin-top-largest"
            style={{ borderRadius: 8 }}
          />
          <Text.Title>Slite is on mobile</Text.Title>
          <Text.Corpus className="margin-top-small margin-bottom-largest center-text">
            Download the app to use Slite on mobile
          </Text.Corpus>
          {isAndroid()
            ? DownloadButton({
                to:
                  'https://play.google.com/store/apps/details?id=com.slite.mobile',
                icon: <GooglePlayIcon size={24} />,
                text: 'Get it on',
                title: 'Google Play',
              })
            : DownloadButton({
                to:
                  'https://itunes.apple.com/app/slite/id1342934691?ls=1&amp;mt=8',
                icon: <IOSIcon size={24} />,
                text: 'Download for',
                title: 'iOS',
              })}
        </div>

        <div className="flexbox flexbox-align-center">
          <div className="flexbox flexbox-column flexbox-align-start shade-20 margin-right-medium">
            <span className="margin-bottom-small">Domain</span>
            {userEmail && <span>Email</span>}
          </div>
          <div className="flexbox flexbox-column flexbox-align-start shade-05">
            <span className="margin-bottom-small">
              {organizationDomain}
              .slite.com
            </span>
            {userEmail && <span>{userEmail}</span>}
          </div>
        </div>
      </div>
      <div
        className="position-absolute flexbox width-full flexbox-centered"
        style={{ bottom: 40 }}
      >
        <a href="https://slite.com">
          <img
            src="https://storage.googleapis.com/slite-cdn/logos/slite/grey.svg"
            height="15"
            width="60"
            alt="slite"
          />
        </a>
      </div>
    </div>
  )
}
